import FileMappingWizardComponentList from '../component-list';
import React, {Fragment} from 'react';
import {selectFileMappingWizardCubeComponentListComponent} from './actions';
import {connect} from 'react-redux';
import ReduxCodelistDetailModal from "../../../../../redux-components/redux-codelist-detail-modal";
import {DM_FILE_MAPPING_WIZARD_CUBE_COMPONENT_LIST_PREFIX} from "./reducer";
import {reuseAction} from "../../../../../utils/reduxReuse";
import {showCodelistDetail} from "../../../../../redux-components/redux-codelist-detail-modal/actions";
import {getArtefactTripletFromString} from "../../../../../utils/sdmxJson";

const mapStateToProps = state => ({
  appLanguage: state.app.language,
  nodeId: state.app.endpointId,
  nodes: state.config.nodes,
  cube: state.scenes.dataManager.fileMapping.components.wizard.shared.cube,
  codelistDetail: state.scenes.dataManager.fileMapping.components.wizard.components.cubeComponentList.codelistDetail,
  selectedCubeComponentCode: state.scenes.dataManager.fileMapping.components.wizard.shared.selectedCubeComponentCode,
  components: state.scenes.dataManager.fileMapping.components.wizard.shared.components,
});

const mapDispatchToProps = dispatch => ({
  onCodelistShow: (codelistTriplet, defaultItemsViewMode) =>
    dispatch(reuseAction(showCodelistDetail(codelistTriplet, defaultItemsViewMode), DM_FILE_MAPPING_WIZARD_CUBE_COMPONENT_LIST_PREFIX)),
  onCubeComponentSelect: cubeComponentCode => dispatch(selectFileMappingWizardCubeComponentListComponent(cubeComponentCode)),  
});

const FileMappingWizardCubeComponentList = ({    
                                              appLanguage,
                                              nodeId,
                                              nodes,
                                              cube,
                                              codelistDetail,
                                              selectedCubeComponentCode,
                                              components,
                                              onCodelistShow,
                                              onCubeComponentSelect,
                                              componentValueDefinitionFormVisible,
                                              onComponentValueDefinitionFormShow,
                                              onComponentValueDefinitionFormHide,
                                              onComponentValueDefinitionSave,
                                              onComponentValueDefinitionTypeSet,
                                              componentValueDefinition,
                                              onComponentValueDefinitionValueSet,
                                              componentCodelistCodesItemsPage,
                                              componentCodelistCodesItemsCount,
                                              fetchCodelistCodesItemsPage
                                            }) => {

  const defaultItemsViewMode = nodes.find(node => node.general.id === nodeId).general.defaultItemsViewMode;

  const mappedCubeComponents = components.map(comp => comp.CubeComponentCode);

  return (
    <Fragment>
      <ReduxCodelistDetailModal
        instancePrefix={DM_FILE_MAPPING_WIZARD_CUBE_COMPONENT_LIST_PREFIX}
        instanceState={codelistDetail}
      />
      <FileMappingWizardComponentList
        components={
          cube !== null
            ? (
              [
                ...cube.components.dimensions.map(dim => ({
                  ...dim,
                  icon: 'bar-chart',
                  canAssociateValue: true
                })),
                ...cube.components.timeDimensions.map(dim => ({
                  ...dim,
                  icon: 'clock-circle',
                  canAssociateValue: true
                })),
                ...cube.components.attributes.map(attr => ({
                  ...attr,
                  icon: 'profile',
                  canAssociateValue: true
                })),
                ...cube.components.measures.map(meas => ({
                  ...meas,
                  icon: 'line-chart',
                  canAssociateValue: false
                  
                }))
              ]
                .map((comp, idx) => ({
                  ...comp,
                  name: comp.Code,
                  key: idx,
                  calculated: false,
                  onDetail:
                    comp.CodelistCode !== undefined && comp.CodelistCode !== null
                      ? () => onCodelistShow(getArtefactTripletFromString(comp.CodelistCode), defaultItemsViewMode)
                      : null
                }))
            ) :
            []
        }
        appLanguage={appLanguage}
        selected={selectedCubeComponentCode !== null ? selectedCubeComponentCode : null}
        onSelect={({Code}) => onCubeComponentSelect(Code)}
        disabled={mappedCubeComponents}
        hasIcon={true}
        showValueDefinitionButton={true}
        componentValueDefinitionFormVisible={componentValueDefinitionFormVisible}
        onComponentValueDefinitionFormShow={onComponentValueDefinitionFormShow}
        onComponentValueDefinitionFormHide={onComponentValueDefinitionFormHide}
        onComponentValueDefinitionSave={onComponentValueDefinitionSave}
        onComponentValueDefinitionTypeSet={onComponentValueDefinitionTypeSet}
        componentValueDefinition={componentValueDefinition}
        onComponentValueDefinitionValueSet={onComponentValueDefinitionValueSet}
        componentCodelistCodesItemsPage={componentCodelistCodesItemsPage}
        componentCodelistCodesItemsCount={componentCodelistCodesItemsCount}
        fetchCodelistCodesItemsPage={fetchCodelistCodesItemsPage}
      />
    </Fragment>
  )
};

export default connect(mapStateToProps, mapDispatchToProps)(FileMappingWizardCubeComponentList);
